import { render, staticRenderFns } from "./MAccordion.vue?vue&type=template&id=1e9b82a1&"
import script from "./MAccordion.vue?vue&type=script&lang=js&"
export * from "./MAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports